import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  enable_teacher_portal: false,
  has_ux_tester_role_enabled: false,
  enable_vcc_course_and_unit_report: false,
};

export default {
  state,
  actions,
  getters,
  mutations,
};
